import * as React from 'react';
import { IconMagnifier, IconRemove } from '@SBGSports/referee-react/icons';
import { Input } from '@SBGSports/referee-react';
import { useTranslations } from 'i18n';

interface TableSearchProps {
    searchText: string;
    setSearchText: (text: string) => void;
    testId?: string;
}

export const TableSearch: React.FC<TableSearchProps> = (props) => {
    const { searchText, setSearchText, testId = '' } = props;
    const { __ } = useTranslations();
    return (
        <Input
            data-testid={testId.concat('import-search-input')}
            placeholder={__('misc.search')}
            size={'small'}
            value={searchText}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSearchText(event.target.value)}
            endAdornmentSlot={
                searchText ? (
                    <IconRemove
                        data-testid={testId.concat('import-search-clear')}
                        style={{
                            pointerEvents: 'all',
                            cursor: 'pointer',
                        }}
                        onClick={() => setSearchText('')}
                    />
                ) : (
                    <IconMagnifier />
                )
            }
        />
    );
};
